import Accordion from './Accordion'
import AccordionContent from './AccordionContent'
import AccordionHeader from './AccordionHeader'

export default (editor, config = {}) => {
  const dc = editor.DomComponents
  const defaultType = dc.getType('default')
  const defaultModel = defaultType.model
  const defaultView = defaultType.view
  const opts = {
    ...config,
    defaultModel,
    defaultView
  }

  Accordion(editor, opts)
  AccordionContent(dc, opts)
  AccordionHeader(dc, opts)
}
